import {translations} from 'locales/translations';
import {__} from 'utils/messages';

export default {
  value: () => __(translations.productsStockPage.value, 'Value'),
  quantity: () => __(translations.productsStockPage.quantity, 'Quantity'),
  alerts: () => __(translations.productsStockPage.alerts, 'Alerts'),
};
